import trI18n from '@/common/utils/trI18n';
import * as yup from "yup";
import Schema from '@/schema/Schema';
import tr from '@/common/utils/tr';
import I18n from '@/rI18n';

const UserProfileSchema =  Schema.object().shape({
    lastName: yup
        .string()
        // Message functions: translated at validation time, not frozen at module import
        .required(() => trI18n('COMMSG014'))
        .max(200, () => tr(I18n.get('COMMSG027').replace('{{maxLength}}', '200'))),

    firstName: yup
        .string()
        .required(() => trI18n('COMMSG014'))
        .max(200, () => tr(I18n.get('COMMSG027').replace('{{maxLength}}', '200')))
});

export default UserProfileSchema;
